module.exports = __webpack_public_path__ + "media/images/leadership_characteristics/bg-2-4bf3eabe808f461e279732d1248def1e.png";